import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Note } from '../models/note.dto';

@Injectable({
  providedIn: 'root'
})
export class EnrollementService {

  constructor(private http: HttpClient) { }

  send(uuid: string) {
    return this.http.post<any>(environment.beServiceUrl + '/v1/enrollment/enroll', {transitionId: uuid});
  }

  getLast(uuid: string) {
    const url= environment.beServiceUrl + `/v1/enrollment/last?transitionUuid=${uuid}`;
    return this.http.get<any>(url);
  }

  getAll(uuid: string) {
    const url= environment.beServiceUrl + `/v1/enrollment/all?transitionUuid=${uuid}`;
    return this.http.get<any>(url);
  }

  revoke(uuid: string) {
    const url= environment.beServiceUrl + `/v1/enrollment/revoke?transitionUuid=${uuid}`;
    return this.http.put<any>(url, null);
  }
}
